import SettingsIcon from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-location';

interface TaxConfigurationPromptProps {
    propertyId: number;
}

const TaxConfigurationPrompt = ({ propertyId }: TaxConfigurationPromptProps) => {
    const navigate = useNavigate();

    return (
        <Card
            sx={{
                border: '3px solid #374151',
                borderRadius: 0,
                backgroundColor: '#1a1a2e',
            }}
        >
            <CardContent sx={{ p: 4 }}>
                <Stack spacing={3} alignItems="center" textAlign="center">
                    <Box
                        sx={{
                            p: 2,
                            border: '3px solid #f59e0b',
                            backgroundColor: 'rgba(245, 158, 11, 0.1)',
                        }}
                    >
                        <SettingsIcon sx={{ color: '#f59e0b', fontSize: 48 }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 900,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                                mb: 1,
                            }}
                        >
                            Configure Tax Profile
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ color: 'text.secondary', maxWidth: 500 }}
                        >
                            Set up your tax profile to see estimated tax obligations and
                            better understand your net income after taxes.
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={() => navigate({ to: `/${propertyId}/settings` })}
                        sx={{
                            borderRadius: 0,
                            border: '3px solid #f59e0b',
                            backgroundColor: '#f59e0b',
                            color: '#0f0f23',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            px: 4,
                            py: 1.5,
                            '&:hover': {
                                backgroundColor: '#d97706',
                                borderColor: '#d97706',
                            },
                        }}
                    >
                        Configure Tax Settings
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default TaxConfigurationPrompt;
